import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { PayrollPaydayCardComponent } from './home-cards/payroll-payday-card/payroll-payday-card.component';
import { PayrollService } from './payroll.service';
import moment from 'moment-mini';
import { PayrollPendingCardComponent } from './home-cards/payroll-pending-card/payroll-pending-card.component';
import { PayrollCompleteCardComponent } from './home-cards/payroll-complete-card/payroll-complete-card.component';

@Injectable({ providedIn: 'root' })
export class PayrollCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _payrollService = inject(PayrollService);
  private _unsub$ = new Subject<void>();

  constructor() {
    this._serviceInventory
      .getService('payroll')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
              this.setPayrollPayDayInfo();
              break;
            case ServiceState.PENDING:
              this.setPayrollPayDayInfo();
              this.registerPayrollPendingCard();
              break;
            case ServiceState.COMPLETE:
              this.setPayrollPayDayInfo();
              this.registerPayrollCompleteCard();              
              break;
            case ServiceState.MAINTENANCE:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.next();
  }

  private setPayrollPayDayInfo(): void {
    this._payrollService.getPayrollSchedule().subscribe((res) => { 
      const payDate = res?.payDate;     
      if (!payDate) { 
        this.removePayrollPaydayCard();
        return;
      }
      const today = moment().startOf('day');
      const target = moment(payDate).startOf('day');
      const remainingDays = target.diff(today, 'days');
      
      if (remainingDays >= 0) this.registerPayrollPaydayCard(remainingDays);
      else this.removePayrollPaydayCard();
    });
  }

  private registerPayrollPaydayCard(remainingDays: number) {
    this._homeFeedService.registerHomeFeedCard({
      key: 'payroll_payday',
      component: 'PayrollPaydayCardComponent',
      componentRef: PayrollPaydayCardComponent,
      section: HomeFeedSection.PAYDAY,
      data: { remainingDays },
      order: 1
    });
  }

  private registerPayrollPendingCard() {        
    this._homeFeedService.registerHomeFeedCard({
      key: 'payroll',
      component: 'PayrollPendingCardComponent',
      componentRef: PayrollPendingCardComponent,
      section: HomeFeedSection.MYMONEYINFO,
      order: 1
    });
  }

  private registerPayrollCompleteCard() {    
    this._homeFeedService.registerHomeFeedCard({
      key: 'payroll',
      component: 'PayrollCompleteCardComponent',
      componentRef: PayrollCompleteCardComponent,
      section: HomeFeedSection.MYMONEYINFO,
      order: 1
    });
  }

  private removePayrollPaydayCard() {
    this._homeFeedService.removeHomeFeedCard('payroll', HomeFeedSection.PAYDAY);
  }
}
